<template>
  <div class="visitor-list-page">
    <vue-headful title="Посетители" />
    <div class="container">
      <div class="visitor-block">
        <div class="profile-content">
          <div class="row">
            <div class="col-md-8">
              <h2>Посетители</h2>
            </div>
          </div>

          <hr>

          <div class="row filters-block">
            <div class="col-md-5">
              <div class="row">
                <div class="input-group">
                  <input
                    v-model="search"
                    ref="searchBar"
                    type="text"
                    class="form-control"
                    placeholder="Поиск по посетителям"
                    @change="changeSearch($event)"
                  >
                  <div class="input-group-btn">
                    <button type="button" class="btn btn-default" @click="handleSearch()">
                      <span class="glyphicon glyphicon-search"></span>
                    </button>
                    <dropdown ref="dropdown">
                      <btn type="" class="dropdown-toggle btn btn-default">
                        <span class="glyphicon glyphicon-filter"></span>
                      </btn>
                      <template v-slot:dropdown>
                        <li v-for="(label, column) in filterColumnsData"
                          :key="label"
                          :value="column"
                          @click="handleFilter(column)"
                        >
                          <a role="button">{{ label }}</a>
                        </li>
                      </template>
                    </dropdown>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="active-filter">
                  <small>
                    <span class="glyphicon glyphicon-filter"></span>
                    &nbsp;
                    <b id="active-filter">{{ columnsFilterParams }}</b>
                  </small>
                </div>
                <label class="applicant-helpers flex-label">
                  <input v-model="requiredArchived" type="checkbox" @change="insertSearchParams" />
                  &nbsp;
                  Включать архивные заявки
                </label>
              </div>
            </div>
          </div>

          <div v-if="visitors && visitors.length" class="row">
            <div class="col-md-12 visitor-list">
              <visitor-item
                v-for="(visitor, key) in visitors"
                :key="key"
                :visitor=visitor
                :visitor-key="Number(key)"
                :visitor-blacklist="visitorsBlacklist[visitor.id]"
                :user="user"
                :statuses="statuses"
                :applicationMenuConfiguration="applicationMenuConfiguration"
                :passport-hash-search="passportHashSearch"
                :required-archived="requiredArchived"
              />
            </div>
          </div>

          <infinite-loading :identifier="infiniteId" @infinite="infiniteLoadVisitors">
            <div slot="no-more">Показаны все записи</div>
            <div slot="no-results">Нет записей</div>
          </infinite-loading>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApplicationClient from '../../helpers/api-client/Application'
import actionListMenuItemCommandMixin from '@/common/mixins/actionListMenuItemCommandMixin'
import VisitorClient from '../../helpers/api-client/Visitor'
import VisitorItem from './VisitorItem.vue'
import { ApiClient } from '../../helpers/api-client/ApiClient'
import PermissionsEnum from '@/common/enums/PermissionsEnum'

export default {
  name: 'VisitorList',

  components: { VisitorItem },

  mixins: [actionListMenuItemCommandMixin],

  data: function () {
    return {
      applicationMenuConfiguration: { type: Object },
      baseUrl: process.env.VUE_APP_API_BASE_URL,
      filterColumns: null,
      requiredArchived: false,
      filterColumnsData: {
        all: 'Все поля'
      },
      infiniteId: 0,
      pagination: {
        active: 1,
        per: 10
      },
      preloader: true,
      search: null,
      searchChanged: false,
      statuses: { type: Object },
      visitors: [],
      visitorsBlacklist: {}
    }
  },

  computed: {
    columnsFilterParams() {
      return this.filterColumnsData[this.filterColumns] ?? this.filterColumnsData.all
    },

    filterParams() {
      return {
        search: this.search,
        filterColumns: this.filterColumns,
        page: this.pagination.active,
        requiredArchived: this.requiredArchived
      }
    },

    passportHashSearch() {
      return this.filterColumns === 'passport_hash' &&
        this.search !== undefined &&
        this.search !== null &&
        this.search !== ''
    }
  },

  async created() {
    const vue = this
    this.pagination.active = history.state?.page ?? 1
    await this.fetchData()

    this.hidePreloader()
    window.addEventListener('popstate', (event) => {
      if (event.state) {
        vue.fillSearchParamsFromState(event)
        vue.clearSearch(this.pagination.active)
      }
    })
  },

  methods: {
    changeSearch(event) {
      this.searchChanged = true

      this.search = event.target.value
      this.insertSearchParams()
      this.clearSearch(this.pagination.active)

      setTimeout(() => {
        this.searchChanged = false
      }, 500)
    },

    async clearSearch(page) {
      this.pagination.active = page
      this.visitors = []
      this.infiniteId += 1
    },

    async fetchCfgMenuApplication() {
      await ApiClient.cfgMenuDataApplicationMenu({
        type: 'application'
      }).then((response) => {
        this.applicationMenuConfiguration = response.data.data
      })
    },

    async fetchData() {
      this.statuses = await ApplicationClient.statuses().then(response => response.data)
      await this.fetchCfgMenuApplication()
      const data = await VisitorClient.extraData().then(response => response.data)
      this.setExtraData(data)
    },

    fillSearchParamsFromState({ search, filterColumns, page, requiredArchived }) {
      this.search = search ?? ''
      this.filterColumns = filterColumns ?? 'all'
      this.pagination.active = page ?? 1
      this.requiredArchived = requiredArchived ?? false
    },

    async getPageVisitors(activePage, perPage = null) {
      let results = []

      await VisitorClient.getList({
        page: activePage,
        perPage: perPage || this.pagination.per,
        searchQuery: this.search,
        filterColumns: this.filterColumns
      }).then((response) => {
        results = response?.data?.data?.models
      })

      return results
    },

    handleFilter(value) {
      const columnLabel = this.filterColumnsData[value] ?? 'Все поля'
      const filter = document.getElementById('active-filter')
      filter.textContent = columnLabel
      this.filterColumns = value
      this.insertSearchParams()
      this.clearSearch(this.pagination.active)
    },

    handleSearch() {
      if (this.searchChanged) {
        return
      }
      this.searchChanged = true
      this.clearSearch('1')

      setTimeout(() => {
        this.searchChanged = false
      }, 500)
    },

    async checkBlacklist(visitors) {
      const visitorIds = visitors.map(visitors => visitors.id)
      let result = []
      await ApiClient.checkBlacklistVisitors(visitorIds).then((response) => {
        const responseData = response.data
        result = responseData.data
      })

      return result
    },

    async infiniteLoadVisitors($state) {
      let visitors
      if (!this.visitors.length) {
        this.pagination.active = 1
        if (Object.keys(this.$route.query).length) {
          this.fillSearchParamsFromState({
            search: this.search ?? this.$route.query.search,
            filterColumns: this.filterColumns ?? this.$route.query.filterColumns,
            requiredArchived: this.$route.query.requiredArchived === 'true' ?? false
          })
        }
      }

      visitors = await this.getPageVisitors(this.pagination.active)
      await this.fillBlacklist(visitors)

      if (visitors?.length) {
        this.pagination.active++
        this.visitors.push(...visitors)
        $state.loaded()
      } else if (visitors?.length === 0) {
        $state.complete()
      } else {
        $state.error()
      }

      this.replaceStatePageData()
    },

    async insertSearchParams() {
      this.pagination.active = 1
      await this.$router.push({ query: { ...this.filterParams } })
    },

    replaceStatePageData() {
      const params = history.state ?? this.filterParams
      params.page = this.pagination.active

      const url = new URL(window.location)
      url.searchParams.set('page', this.pagination.active)
      history.replaceState(params, undefined, url.href)
    },

    setExtraData(data) {
      this.filterColumnsData = { ...this.filterColumnsData, ...data.filterColumns }
    },

    async fillBlacklist(visitors) {
      if (
        !this.hasPermission(PermissionsEnum.viewGeneralBlacklist) &&
        !this.hasPermission(PermissionsEnum.viewBlacklist)
      ) {
        return
      }

      let CheckBlacklist = await this.checkBlacklist(visitors)
      Object.keys(CheckBlacklist).forEach((visitorId) => {
        this.visitorsBlacklist[visitorId] = CheckBlacklist[visitorId]
      })
    }
  }
}
</script>
